import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { APP_CONFIG } from '../config/app-config';
import { AuthService } from './auth.service';

/**
 * Route guard (T-058/T-067, NFR-01). Allows navigation for authenticated users;
 * otherwise starts an interactive sign-in and blocks the route.
 */
export const msalGuard: CanActivateFn = () => {
  const config = inject(APP_CONFIG);
  if (!config.authEnabled) {
    return true;
  }
  const auth = inject(AuthService);
  if (auth.isAuthenticated()) {
    return true;
  }
  void auth.login();
  return false;
};
